module.exports = __webpack_public_path__ + "img/1F1F5-1F1F7.cfd2a4cf.svg";